module.exports = __webpack_public_path__ + "img/krachtlogo.450c0b2a.gif";